var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{staticStyle:{"margin":"15px 20px 10px 10px","width":"330px"},attrs:{"dense":"","hide-details":"","dark":"","label":"Unidade","no-data-text":"Nenhuma unidade disponível.","items":_vm.estruturasGerenciais,"value":_vm.estruturaGerencialAtual},on:{"change":_vm.estruturaOnChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }